import React, { useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import { Box, Paper, Typography, Button, TextField, Alert, CircularProgress, Stack } from "@mui/material";
import LogoHome from "./LogoHome";

function ResetPasswordForm() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const uid = searchParams.get("uid");
  const token = searchParams.get("token");

  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const API_URL = process.env.REACT_APP_API_URL;

  const onSubmit = async e => {
    e.preventDefault();
    setError("");
    setMessage("");
    if (password !== confirm) {
      setError("Passwords do not match !");
      return;
    }
    setLoading(true);
    try {
      const response = await fetch(`${API_URL}/api/reset-password/confirm/`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ uid, token, password }),
      });
      const data = await response.json();
      if (response.ok) {
        setMessage("Password modified! You can now try to connect");
        setPassword("");
        setConfirm("");
      } else {
        setError(data.detail || "An error occured while modifying password");
      }
    } catch (err) {
      setError("Failed to connect to the server");
    }
    setLoading(false);
  };

  return (
    <Box display="flex" justifyContent="center" alignItems="center" minHeight="100vh" bgcolor="#f8fafc">
      <Paper elevation={3} sx={{ p: 4, minWidth: 350, textAlign: "center" }}>
        <LogoHome size={110} />
        <Typography variant="h5" align="center" gutterBottom>
          Réinitialisation du mot de passe
        </Typography>
        <Typography variant="body2" color="textSecondary" sx={{ mb: 2 }}>
          Veuillez saisir un nouveau mot de passe&nbsp;:
        </Typography>
        <form onSubmit={onSubmit}>
          <TextField
            label="New password"
            type="password"
            margin="normal"
            fullWidth
            value={password}
            onChange={e => setPassword(e.target.value)}
            required
          />
          <TextField
            label="Confirm new password"
            type="password"
            margin="normal"
            fullWidth
            value={confirm}
            onChange={e => setConfirm(e.target.value)}
            required
          />
          <Button
            type="submit"
            variant="contained"
            color="primary"
            fullWidth
            sx={{ mt: 2 }}
            disabled={loading}
            startIcon={loading ? <CircularProgress size={20} /> : null}
          >
            Réinitialiser
          </Button>
        </form>
        {error && (
          <Alert severity="error" sx={{ mt: 2 }}>
            {error}
          </Alert>
        )}
        {message && (
        <Alert severity="success" sx={{ mt: 2 }}>
            <Stack direction="column" alignItems="flex-start" spacing={1}>
            <span>{message}</span>
            <Button
                color="success"
                variant="text"
                onClick={() => navigate("/login")}
            >
                Se connecter
            </Button>
            </Stack>
        </Alert>
        )}
      </Paper>
    </Box>
  );
}

export default ResetPasswordForm;